import { Typography } from '@design-system';
import { Holiday, HolidayState, HolidayType } from '@services';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './HolidayItem.scss';
import { HolidayStatusProvider } from './HolidayStatusProvider';

export type HolidayItemProps = Holiday & {
    holidayTypes: HolidayType[];
    operator: string;
} & React.HTMLAttributes<HTMLDivElement>;

export const HolidayItem: React.FC<HolidayItemProps> = ({
    id,
    date_start,
    date_end,
    state_id,
    operator,
    holidayTypes,
    type_id,
    ...props
}) => {
    const navigate = useNavigate();

    return (
        <div
            className="holiday-item"
            {...props}
            onClick={() => (state_id !== HolidayState.ACCEPTED ? navigate(`/richesses-humaines/conges/${id}`) : null)}
        >
            <div className="holiday-item__date">
                <Typography intrinsic="p" color="grey">
                    Demande #{id}
                </Typography>

                <Typography intrinsic="p" color="grey" className="my-x-small-spacing">
                    ({holidayTypes.find((holidayType) => `${holidayType.id}` === `${type_id}`)?.label})
                </Typography>

                <Typography intrinsic="p" color="marine" className="mb-medium-spacing">
                    {operator}
                </Typography>

                <Typography intrinsic="h4">
                    {new Date(date_start).toLocaleDateString('fr-FR', {
                        day: '2-digit',
                        month: '2-digit',
                        year: '2-digit'
                    })}{' '}
                    -{' '}
                    {new Date(date_end).toLocaleDateString('fr-FR', {
                        day: '2-digit',
                        month: '2-digit',
                        year: '2-digit'
                    })}
                </Typography>
            </div>
            <HolidayStatusProvider status={state_id} />
        </div>
    );
};
